<template>
	<div class="contain_body">
		<el-row :gutter="40">
			<!-- 导航 -->
			<el-col :span="6">
				<el-menu :default-active="navIndex" class="el-menu-vertical-demo" router>
					<el-card class="box-card">
						<template v-for="item in navs">
							<el-menu-item :index="item.url">
								{{item.name}}
							</el-menu-item>
						</template>
					</el-card>
				</el-menu>
			</el-col>

			<!-- 内容 -->
			<el-col :span="18">
				<el-card class="box-card" v-loading="loading" element-loading-text="加载中...">
					<!-- 判断data是否为空 -->
					<template v-if="data.length != 0">
						<!-- 内容 -->
						<template v-if="displayType == 'nolist'">
							<div class="article_title">{{data.title}}</div>
							<div class="article_flex">
								<template v-if="data.time_state == 1">
									<div class="item" v-if="data.created_at != ''">发布时间：{{data.created_at}}</div>
								</template>
								<template v-if="data.time_state == 1">
									<div class="item" v-if="data.author != ''">作者：{{data.author}}</div>
								</template>
								<template v-if="data.time_state == 1">
									<div class="item" v-if="data.source != ''">来源：{{data.source}}</div>
								</template>
							</div>
							
							<div class="article_body" v-html="data.content"></div>
							
							<template v-if="data.files_state == 1">
								<ul class="enclosure_body" v-if="data.files.length != 0">
									<div style="margin-bottom: 10px;">附件：</div>
									<template v-for="(item,index) in data.files">
										<li><a :href="item.location">{{index+1}}、{{item.fileName}}</a></li>
									</template>
								</ul>
							</template>
							
						</template>
						
						<!-- 列表 -->
						<template v-else-if="displayType == 'list'">
							<ul class="list">
								<template v-for="item in data">
									<li @click="link(item.url,item.jump_type)">
										<div class="name">{{item.title}}</div>
										<div class="time">{{item.created_at}}</div>
									</li>
								</template>
							</ul>
						
						
							<div class="paging">
								<el-pagination background layout="prev, pager, next , total" :total="pageCount.totalCount"
									@current-change="handleCurrentChange" :page-size="pageCount.pageSize">
								</el-pagination>
							</div>
						</template>
						
					</template>
					<template v-else>
						<el-empty description="暂无内容"></el-empty>
					</template>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		name: 'App',
		data() {
			return {
				id: '', //当前页面id
				navs: [], //导航数据
				navIndex: '', //导航选中下标
				displayType: '', //显示类型，是显示列表还是内容
				data: '', //右边内容，可以是列表，也可以是内容
				cid: '',
				page: 1, //页数
				pageCount: [], //页数
				loading: false
			};
		},
		methods: {
			//获取当前链接参数
			getParams(name) {
				var search = window.location.search.substring(1)
				if (!search) {
					search = window.location.hash.split('?')[1]
				}
				if (search) {
					var obj = JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","')
						.replace(/=/g, '":"') + '"}')
					return name ? obj[name] : obj
				}
			},

			//请求导航信息
			query_nav(id) {
				var that = this
				that.navs = []
				this.$http.get('/nav-child/' + that.id).then((res) => {

					that.navs = res.data.data

					//导航选中事件
					that.nav_check()

					//请求右边内容
					that.query_content()
				})
			},

			//导航选中事件
			nav_check() {
				var that = this
				for (var i in that.navs) {
					if (that.navs[i].id == that.id) {
						that.navIndex = that.navs[i].url;
					}
				}
			},

			//请求右边内容
			query_content() {
				var that = this
				let cid = ''
				if (that.cid == undefined) {
					that.$http.get('/news-info/' + that.id + '?page=' + that.page).then((res) => {
						that.displayType = res.data.type
						that.data = res.data.data
						that.loading = false
						that.pageCount = res.data.page
					})
				} else {
					that.$http.get('/news-info/' + that.id + '?cid=' + that.cid).then((res) => {
						that.displayType = res.data.type
						that.data = res.data.data
						that.loading = false
					})
				}


			},

			//点击跳转
			link(link,type) {
				if(type == 'local'){
					this.$router.push(link);
				}else if(type == 'web'){
					window.open(link)
				}
			},

			//子组件向父组件传值导航下标index
			goShopList(value) {
				this.$emit('getShopCode', value)
				// this.$router.push({name:'shopList'});
			},

			//点击分页进行切换
			handleCurrentChange(val) {
				var that = this
				this.loading = true
				this.page = val
				//请求右边内容
				that.query_content()
				
			}
		},
		created() {
			var that = this
			document.title = '中国智慧工程研究会职业教育专业委员会';
			//获取当前页面路径的id
			this.id = this.getParams().index
			this.cid = this.getParams().cid
			that.loading = true
			this.query_nav(this.id)
		},
		watch: {
			//监听路由地址的改变
			$route: {
				handler(val, oldval) {
					this.loading = true
					//获取当前页面路径的id
					this.id = val.query.index
					this.cid = val.query.cid

					this.query_nav(this.id)
					this.goShopList(val.fullPath)
				},
				// 深度观察监听
				deep: true
			}
		},
	}
</script>

<style>
	.contain_body{
		width: 1190px;
		margin: 0 auto;
		min-height: 180px;
		padding: 30px 0;
	}
	.el-menu-item{
		border-radius: 8px;
	}
	.el-menu-item:hover{
		color: #fff;
	}
	.article_title{
		/* width: 520px; */
		font-size: 26px;
		color: #303133;
		text-align: center;
		margin: 20px auto 10px;
		font-weight: bold;
	}
	.article_flex{
		display: flex;
		margin-bottom: 28px;
		justify-content: center;
	}
	
	.article_flex .item{
		padding: 0 20px;
		color: #606266;
	}
	.article_body {
		line-height: 35px;
	}
	.article_body p{
		 margin-bottom: 10px;
	}
	.article_body img{
		max-width: 100%;
		height:auto !important;
		margin: 10px auto;
	}

	.el-menu {
		border-right: 0;
	}

	.el-menu-item.is-active {
		font-size: 16px;
		font-weight: bold;
	}

	.list li {
		border-bottom: 1px solid #EBEEF5;
		display: flex;
		justify-content: space-between;
		padding: 15px 0;
		cursor: pointer;
		font-size: 14px;
	}

	.list li .name {
		font-size: 16px;
		color: #606266;
		width: 740px;
		word-wrap: break-word;
		/*强制换行*/
		overflow: hidden;
		/*超出隐藏*/
		text-overflow: ellipsis;
		/*隐藏后添加省略号*/
		white-space: nowrap;
		/*强制不换行*/
	}

	.list li .time {
		color: #909399;
	}

	.paging {
		text-align: center;
		margin-top: 40px;
	}
	.enclosure_body{
		margin-top: 30px;
		color: #909399;
	}
	.enclosure_body li{
		font-size: 14px;
		line-height: 25px;
		color: #909399;
	}
	.enclosure_body li a{
		color: #024E8D;
		margin-left: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/views/article.vue